import React from 'react';
import './InquiryComplete.css'; 
function InquiryComplete() {
  return (
    <div className="submit-complete wrapper">
      <h1>お問い合わせ内容を送信いたしました。</h1> 
      <div className='Inquiey_h3'>
        <h3>通常5営業日以内にご返信させていただいておりますが、1週間経過後もご連絡が無い場合には、誠に申し訳ありませんが、再度お問い合わせ下さい。</h3>
        <h3>なお、問い合わせ受付の自動返信メールを受信されていない場合、カスタマーサポートからのメールも受信できない状態となっている可能性がございます。その場合は、ドメイン「ra9.jp 」やアドレス「ra9-cs@eu-phoria.jp」の受信許可をしていただくなど、返信メールが受信できるようご対応いただいた上で、再度お問い合わせいただけますようお願いいたします。</h3>
      </div>
      <div className='Inquiey_h4'>
        <h4>らくらく連絡網カスタマーサポート：ra9-cs@eu-phoria.jp</h4>
      </div>
    </div>
  );
}
export default InquiryComplete;